import CurrentCaseRequired from "../components/ui/current-case-required.js";
import { QuotaManagementForm, QuotaManagementSkeleton } from "../components/ui/QuotaManagementForm.js";
import { useGetQuotas, useUpdateQuotas } from "../api/quotas.js";
import CaseDatabaseCheck from "../components/ui/case-database-check.js";



export default function QuotaManagementPage(props) {
    const quotasResult = useGetQuotas()
    const updateQuotas = useUpdateQuotas()



    if (quotasResult.isLoading || !quotasResult.data) {
        return <QuotaManagementSkeleton />;
    }

    if (quotasResult.error) {
        return <div>Error: {quotasResult.error.message}</div>
    }

    return (
        <CaseDatabaseCheck>
        <CurrentCaseRequired>
            <QuotaManagementForm quotaData={quotasResult.data} onSave={updateQuotas} />
        </CurrentCaseRequired>
        </CaseDatabaseCheck>
    );
}